import CONST from "./Constant";

const INITIAL_STATE = {
    list:[],
    selected:{},
    error: [],
    code: "",
    config:{
        from:0,
        to:0,
        lastPage:1,
        total:0,
        pagination:{
            page:0,
            pageSize:10,
        },
        filters:{
            keyword:'',
            sort_by:'created_at',
            sort_dir:'desc',
        }
    },
};

const Reducer = (state = INITIAL_STATE, action) => {

    switch (action.type){
        case CONST.SET_CONFIG:
            return {
                ...state,
                config: {
                    ...state.config,
                    ...action.payload
                },
            };
        case CONST.SET_SELECTED_ROLE:
            return {
                ...state,
                selected: state.list.find(item => item.id === action.payload) || {},
            }
        case CONST.FETCH_ROLE_SUCCESS:
            return {
                ...state,
                selected: action.payload.data,
                error: [],
                message: ["Role loaded successfully"],
                code:action.payload.status
            }
        case CONST.FETCH_ROLES_SUCCESS:
            const paginate = action.payload.config.params.paginate
            return paginate === undefined ? {
                ...state,
                list: action.payload.data.data,
                config:  {
                    ...state.config,
                    from:action.payload.data.from,
                    to:action.payload.data.to,
                    lastPage:action.payload.data.last_page,
                    total:action.payload.data.total,
                    pagination:{
                        ...state.config.pagination,
                        page:action.payload.data.current_page - 1,
                        pageSize:action.payload.data.per_page,
                    },
                },
                error: [],
                code:action.payload.status,
                message: ["Roles loaded successfully"],
            } : {
                ...state,
                list: action.payload.data,
                error: [],
                code:action.payload.status,
                message: ["Roles loaded successfully"],
            }
        case CONST.ADD_ROLE_SUCCESS:
            return {
                ...state,
                list:[...state.list, action.payload.data],
                selected: action.payload.data,
                error: [],
                message: ["Role added successfully"],
                code:action.payload.status,
            }
        case CONST.UPDATE_ROLE_SUCCESS:
            const indexU = state.list.findIndex(role => role.id === action.payload.data.id);
            return {
                ...state,
                list: [...state.list.slice(0, indexU), action.payload.data, ...state.list.slice(indexU + 1)],
                selected: action.payload.data,
                error: [],
                message: ["Role updated successfully"],
                code:action.payload.status,
            }
        case CONST.DELETE_ROLE_SUCCESS:
            return {
                ...state,
                list:state.list.filter(item => item.id !== action.payload.data),
                selected: {},
                error: [],
                message: ["Role deleted successfully"],
                code:action.payload.status,
            }
        case CONST.FETCH_ROLE_FAILED:
        case CONST.FETCH_ROLES_FAILED:
        case CONST.ADD_ROLE_FAILED:
        case CONST.UPDATE_ROLE_FAILED:
        case CONST.DELETE_ROLE_FAILED:
        default:
            return state;
    }
}

export default Reducer ;